import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './ProductLegend.scss'

export default class ProductLegend extends PureComponent {
  static propTypes = {
    payload: PropTypes.array
  }

  render() {
    const { payload } = this.props

    return (
      <ul className="product-legend">
        {payload.map((entry, index) => {
          return (
            <li key={`item-${index}`}>
              <span
                className={`fa ${
                  entry.dataKey.includes('unloading') ? 'fa-arrow-circle-up' : 'fa-arrow-circle-down'
                } cargo-type-indicator`}
                style={{ color: entry.color }}
              />
              {entry.value}
            </li>
          )
        })}
      </ul>
    )
  }
}
